export default {
  // 列表
  vendorTypeList: "/settings/vendorType/show",
  // 新增
  vendorTypeAdd: "/settings/vendorType/add",
  // 修改
  vendorTypeUpdate: "/settings/vendorType/update",
  // 逻辑删除
  vendorTypeDelete: "/settings/vendorType/delete",
  // 编辑反显
  vendorTypeById: "/settings/vendorType/vendorTypeById",
};
